/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphDto } from '../../models/submissions-graph-dto';

export interface FactorHitlPercentagePerDayGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
  clientNames?: Array<string>;
  topClients?: number;
}

export function factorHitlPercentagePerDayGet$Plain(http: HttpClient, rootUrl: string, params?: FactorHitlPercentagePerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
  const rb = new RequestBuilder(rootUrl, factorHitlPercentagePerDayGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('clientNames', params.clientNames, {});
    rb.query('topClients', params.topClients, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphDto>>;
    })
  );
}

factorHitlPercentagePerDayGet$Plain.PATH = '/Factor/hitl-percentage-per-day';
